/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Nav_EventsInputs */

const en_candidate_profile_nav_events = /** @type {(inputs: Candidate_Profile_Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events`)
};

const de_candidate_profile_nav_events = /** @type {(inputs: Candidate_Profile_Nav_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veranstaltungen`)
};

/**
* | output |
* | --- |
* | "Events" |
*
* @param {Candidate_Profile_Nav_EventsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_nav_events = /** @type {((inputs?: Candidate_Profile_Nav_EventsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Nav_EventsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_nav_events(inputs)
	return en_candidate_profile_nav_events(inputs)
});